module.exports = "/_next/static/images/x-monotone-8f840af99163d8470997981ac823678c.svg";